export function getQuarter(date = new Date()) {
  return Math.floor(date.getMonth() / 3 + 1);
}
